import { Lock } from 'lucide-react'
import MartyrForm from '../components/MartyrForm'
import { usePublicSettings } from '../hooks/usePublicSettings'

export default function FormPage() {
  const { settings, loading } = usePublicSettings()

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-stone-50">
        <div className="text-stone-400 text-lg">يتحمّل...</div>
      </div>
    )
  }

  if (!settings.form_enabled) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-stone-50 p-4" dir="rtl">
        <div className="max-w-md w-full bg-white rounded-2xl shadow-lg p-10 text-center">
          <div className="flex justify-center mb-5">
            <div className="bg-stone-100 p-5 rounded-full">
              <Lock className="w-10 h-10 text-stone-400" />
            </div>
          </div>
          <h1 className="text-xl font-bold text-stone-800 mb-3">النموذج مغلق</h1>
          <p className="text-stone-500 leading-relaxed">
            {settings.form_closed_message || 'التسجيل مغلق حالياً. يرجى المحاولة لاحقاً.'}
          </p>
        </div>
      </div>
    )
  }

  return <MartyrForm notice={settings.form_notice} />
}
